import React from "react";

export const Settings = () => {
	return (
		<>
			<svg
				id="_073-settings"
				data-name="073-settings"
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="#ef0855"
			>
				<g
					id="Group_1256"
					data-name="Group 1256"
					transform="translate(4.905 4.905)"
				>
					<g id="Group_1255" data-name="Group 1255">
						<path
							id="Path_49257"
							data-name="Path 49257"
							d="M144.095,140a4.095,4.095,0,1,0,1.237,8,.706.706,0,1,0-.426-1.346,2.679,2.679,0,1,1,1.765-1.8.706.706,0,0,0,1.355.4A4.1,4.1,0,0,0,144.095,140Z"
							transform="translate(-140 -140)"
						/>
					</g>
				</g>
				<g id="Group_1258" data-name="Group 1258">
					<g id="Group_1257" data-name="Group 1257">
						<path
							id="Path_49258"
							data-name="Path 49258"
							d="M15.891,6.539h-.354a.234.234,0,0,1-.214-.147l-.006-.015a.236.236,0,0,1,.046-.259l.25-.25a2.112,2.112,0,0,0,0-2.983l-.5-.5a2.109,2.109,0,0,0-2.983,0l-.25.25a.236.236,0,0,1-.258.046l-.013-.005a.235.235,0,0,1-.149-.215V2.109A2.112,2.112,0,0,0,9.352,0h-.7A2.112,2.112,0,0,0,6.539,2.109v.354a.235.235,0,0,1-.149.215l-.014.006a.236.236,0,0,1-.259-.046l-.25-.25a2.109,2.109,0,0,0-2.983,0l-.5.5a2.112,2.112,0,0,0,0,2.983l.25.25a.237.237,0,0,1,.045.261l0,.01a.235.235,0,0,1-.215.149H2.109A2.112,2.112,0,0,0,0,8.648v.7a2.112,2.112,0,0,0,2.109,2.109h.354a.234.234,0,0,1,.214.147l.006.015a.236.236,0,0,1-.046.259l-.25.25a2.109,2.109,0,0,0,0,2.983l.5.5a2.109,2.109,0,0,0,2.983,0l.25-.25a.236.236,0,0,1,.258-.046l.013.005a.235.235,0,0,1,.149.215v.354A2.112,2.112,0,0,0,8.648,18h.7a2.112,2.112,0,0,0,2.109-2.109v-.354a.235.235,0,0,1,.149-.215l.014-.006a.236.236,0,0,1,.259.046l.25.25a2.109,2.109,0,0,0,2.983,0l.5-.5a2.109,2.109,0,0,0,0-2.983l-.25-.25a.236.236,0,0,1-.046-.259l.005-.013a.235.235,0,0,1,.215-.149h.354A2.112,2.112,0,0,0,18,9.352v-.7A2.112,2.112,0,0,0,15.891,6.539Zm.7,2.812a.7.7,0,0,1-.7.7h-.354a1.637,1.637,0,0,0-1.515,1.019l0,.011a1.638,1.638,0,0,0,.351,1.792l.25.25a.7.7,0,0,1,0,.994l-.5.5a.7.7,0,0,1-.994,0l-.25-.25a1.638,1.638,0,0,0-1.793-.35l-.01,0a1.637,1.637,0,0,0-1.019,1.515v.354a.7.7,0,0,1-.7.7h-.7a.7.7,0,0,1-.7-.7v-.354a1.637,1.637,0,0,0-1.02-1.515l-.009,0a1.66,1.66,0,0,0-.638-.128,1.63,1.63,0,0,0-1.155.478l-.25.25a.7.7,0,0,1-.994,0l-.5-.5a.7.7,0,0,1,0-.994l.25-.25a1.637,1.637,0,0,0,.351-1.792l0-.011a1.637,1.637,0,0,0-1.515-1.019H2.109a.7.7,0,0,1-.7-.7v-.7a.7.7,0,0,1,.7-.7h.354A1.638,1.638,0,0,0,3.979,6.924l0-.008a1.637,1.637,0,0,0-.35-1.792l-.25-.25a.7.7,0,0,1,0-.994l.5-.5a.7.7,0,0,1,.994,0l.25.25a1.638,1.638,0,0,0,1.793.35l.01,0A1.637,1.637,0,0,0,7.945,2.464V2.109a.7.7,0,0,1,.7-.7h.7a.7.7,0,0,1,.7.7v.354a1.637,1.637,0,0,0,1.02,1.515l.009,0a1.638,1.638,0,0,0,1.792-.35l.25-.25a.7.7,0,0,1,.994,0l.5.5a.7.7,0,0,1,0,.994l-.25.25a1.636,1.636,0,0,0-.351,1.79l.005.013a1.637,1.637,0,0,0,1.515,1.019h.354a.7.7,0,0,1,.7.7Z"
						/>
					</g>
				</g>
			</svg>
		</>
	);
};
